
<div class="phone-wrapper">
  <form [formGroup]="phoneForm" class="phone-form">   
  <div class="autocomplete-container">
    <p-autoComplete formControlName="prefix" styleClass="country-autocomplete" required="errorState" [forceSelection]="true" (onSelect)="countrySelected($event)" [suggestions]="filteredCountries" (completeMethod)="filterCountry($event)" [completeOnFocus]="true" minLength="0" field="defaultCountryCallingCode" placeholder="Country code" #autocomplete>
      <ng-template let-country pTemplate="item">
        <img aria-hidden [src]="country.flag" />
        <img src="assets/images/flags/flag_placeholder.png" [class]="'flag flag-' + country.code.toLowerCase()"/>
        <span>{{ country.code }}</span>
        <small> ({{ country.defaultCountryCallingCode }})</small>
    </ng-template>
    </p-autoComplete>
    <div class="mat-mdc-form-field-subscript-wrapper mat-mdc-form-field-bottom-align">
      <div class="mat-mdc-form-field-error-wrapper">
        <mat-error class="autocomplete-error phone-prefix-error" *ngIf="phoneForm.touched && phoneForm.get('prefix').hasError('required')">Required</mat-error>  
      </div>
    </div>
  </div>
   
    
    <mat-form-field appearance="outline" class="phone-field-wrapper">
      <input type="tel" matInput id="txtPhone" formControlName="phone" placeholder="Phone number" class="lo_sensitive w-112"/>
      <mat-error class="autocomplete-error" *ngIf="phoneForm.touched && phoneForm.get('phone').hasError('pattern')">only numeric characters allowed</mat-error>
      <mat-error class="autocomplete-error" *ngIf="phoneForm.touched && phoneForm.get('phone').hasError('required')">Required</mat-error>  
    </mat-form-field>
  </form>
</div>
  
  
  
  
    
